import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import classnames from "classnames";

function scanFiles(item, files, maxFiles) {
  if (files === void 0) {
    files = [];
  }

  if (maxFiles === void 0) {
    maxFiles = 0;
  }

  if (files.length > maxFiles) {
    return Promise.resolve();
  }

  if (item.isDirectory) {
    return new Promise(function (resolve) {
      var directoryReader = item.createReader();
      directoryReader.readEntries(function (entries) {
        var p = [];
        entries.forEach(function (entry) {
          p.push(scanFiles(entry, files, maxFiles));
        });
        Promise.all(p).then(function () {
          return resolve();
        });
      }, function () {
        return resolve();
      });
    });
  } else {
    return new Promise(function (resolve) {
      item.file(function (file) {
        if (files.length >= maxFiles) {
          resolve();
          return;
        }

        if (item.fullPath && !file.webkitRelativePath) {
          Object.defineProperties(file, {
            webkitRelativePath: {
              writable: true
            }
          });
          file.webkitRelativePath = item.fullPath.replace(/^\//, "");
          Object.defineProperties(file, {
            webkitRelativePath: {
              writable: false
            }
          });
        }

        files.push(file);
        resolve();
      }, function () {
        return resolve();
      });
    });
  }
}

export var version = "1.0.1";
export var Upload = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Upload, _React$Component);

  function Upload() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "inputRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          maxFiles = _this$props.maxFiles,
          onChange = _this$props.onChange;
      var items = e.target.files || [];
      var files = [];
      var fileLen = Math.min(maxFiles, items.length);

      for (var i = 0; i < fileLen; i++) {
        files.push(items[i]);
      }

      if (onChange) {
        onChange(files);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props2 = _this.props,
          openFileDialogOnClick = _this$props2.openFileDialogOnClick,
          onClick = _this$props2.onClick;

      if (!_this.isDisabledOrReadOnly() && openFileDialogOnClick) {
        var _this$inputRef$curren;

        (_this$inputRef$curren = _this.inputRef.current) === null || _this$inputRef$curren === void 0 ? void 0 : _this$inputRef$curren.click();
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      var _this$props3 = _this.props,
          openFileDialogOnClick = _this$props3.openFileDialogOnClick,
          onKeyDown = _this$props3.onKeyDown;

      if (e.keyCode === 13 && !_this.isDisabledOrReadOnly() && openFileDialogOnClick) {
        var _this$inputRef$curren2;

        (_this$inputRef$curren2 = _this.inputRef.current) === null || _this$inputRef$curren2 === void 0 ? void 0 : _this$inputRef$curren2.click();
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (e) {
      var onDragOver = _this.props.onDragOver;
      e.preventDefault();

      if (onDragOver) {
        onDragOver(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDrop", function (e) {
      var _this$props4 = _this.props,
          directory = _this$props4.directory,
          maxFiles = _this$props4.maxFiles,
          droppable = _this$props4.droppable,
          onDrop = _this$props4.onDrop,
          onChange = _this$props4.onChange;
      var files = [];
      e.preventDefault();

      if (onDrop) {
        onDrop(e);
      }

      if (_this.isDisabledOrReadOnly() || !droppable) return;
      var items = e.dataTransfer.files;

      if (directory) {
        var _items = e.dataTransfer.items;
        var p = [];

        for (var i = 0; i < _items.length; i++) {
          var item = _items[i].webkitGetAsEntry();

          if (item) {
            p.push(scanFiles(item, files, maxFiles));
          }
        }

        Promise.all(p).then(function () {
          if (onChange) {
            onChange(files);
          }
        });
      } else {
        var fileLen = Math.min(maxFiles, items.length);

        for (var _i = 0; _i < fileLen; _i++) {
          files.push(items[_i]);
        }

        if (onChange) {
          onChange(files);
        }
      }
    });

    return _this;
  }

  var _proto = Upload.prototype;

  _proto.isDisabledOrReadOnly = function isDisabledOrReadOnly() {
    return this.props.disabled || this.props.readOnly;
  };

  _proto.render = function render() {
    var _classnames;

    var _this$props5 = this.props,
        prefixCls = _this$props5.prefixCls,
        className = _this$props5.className,
        name = _this$props5.name,
        accept = _this$props5.accept,
        multiple = _this$props5.multiple,
        inputKey = _this$props5.inputKey,
        tabIndex = _this$props5.tabIndex,
        children = _this$props5.children,
        tagName = _this$props5.tagName,
        onChange = _this$props5.onChange,
        disabled = _this$props5.disabled,
        readOnly = _this$props5.readOnly,
        directory = _this$props5.directory,
        openFileDialogOnClick = _this$props5.openFileDialogOnClick,
        maxFiles = _this$props5.maxFiles,
        droppable = _this$props5.droppable,
        restProps = _objectWithoutProperties(_this$props5, ["prefixCls", "className", "name", "accept", "multiple", "inputKey", "tabIndex", "children", "tagName", "onChange", "disabled", "readOnly", "directory", "openFileDialogOnClick", "maxFiles", "droppable"]);

    var cls = classnames(prefixCls, (_classnames = {}, _classnames[prefixCls + "-disabled"] = disabled, _classnames[prefixCls + "-readonly"] = readOnly, _classnames), className);
    var Tag = tagName;
    var inputProps = {
      directory: directory ? "directory" : null,
      webkitdirectory: directory ? "webkitdirectory" : null
    };
    return /*#__PURE__*/React.createElement(Tag, _extends({}, restProps, {
      tabIndex: tabIndex,
      className: cls,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onDragOver: this.handleDragOver,
      onDrop: this.handleDrop
    }), /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
      key: inputKey,
      ref: this.inputRef,
      name: name,
      accept: accept,
      multiple: multiple,
      type: "file",
      style: {
        display: "none"
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: this.handleChange
    })), children);
  };

  return Upload;
}(React.Component);

_defineProperty(Upload, "defaultProps", {
  prefixCls: "rw-upload",
  tagName: "div",
  tabIndex: 0,
  maxFiles: Number.MAX_VALUE,
  droppable: true,
  openFileDialogOnClick: true
});

export default Upload;